import { Reveal, MaskLines } from "./Reveal";
import { CtaButton } from "./CtaButton";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Is the coaching free?",
    a: "No. Every training program with Shabz is paid only. This is high-touch, private mentorship for serious traders — not free content. If you're truly committed, message her and she'll walk you through the investment.",
  },
  {
    q: "Who is this actually for?",
    a: "Established six-figure traders who have hit a wall — the same account size, the same self-sabotage, the same plateau month after month. If you're a beginner looking for free tips, this isn't it.",
  },
  {
    q: "Which markets and styles do you coach?",
    a: "Day trading, swing trading, options, futures and equities. As a 6 figure stock trading coach, Shabz tailors the work to your instrument, timeframe and psychology rather than forcing one rigid system.",
  },
  {
    q: "How much does it cost?",
    a: "Pricing is discussed privately once you reach out. It's a premium, high-ticket program — the investment reflects the level of access and transformation involved.",
  },
  {
    q: "Do you guarantee I'll make money?",
    a: "No. Trading involves substantial risk and no outcome is ever guaranteed. Coaching sharpens your execution, discipline and mindset — it does not remove market risk or promise profits.",
  },
  {
    q: "How do I get started?",
    a: "There's no form, no phone number and no email to chase. Simply message Shabz directly on Instagram. If it's a fit, the conversation begins there.",
  },
];

export const FAQ = () => (
  <section id="faq" className="relative border-t border-white/10 py-24 sm:py-32">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-6 sm:px-8 lg:grid-cols-12 lg:gap-16 lg:px-12">
      <div className="lg:col-span-4">
        <Reveal>
          <span className="font-['IBM_Plex_Mono'] text-[11px] uppercase tracking-[0.3em] text-[#d4af37]">
            Chapter 04 &mdash; Questions
          </span>
        </Reveal>
        <h2 className="mt-8 font-['Playfair_Display'] text-3xl font-medium tracking-tight sm:text-4xl">
          <MaskLines whileInView lineClass="gold-metallic-text" lines={["Before you", "reach out."]} />
        </h2>
        <Reveal delay={0.2}>
          <div className="mt-8 hidden lg:block">
            <CtaButton variant="secondary" testid="faq-cta" />
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-8">
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border-white/10">
              <AccordionTrigger className="py-6 text-left font-['Playfair_Display'] text-lg text-[#f5f5f0] hover:text-[#d4af37] hover:no-underline sm:text-xl">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-base leading-relaxed text-[#a1a1aa]">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        <div className="mt-10 lg:hidden">
          <CtaButton variant="secondary" testid="faq-cta-mobile" />
        </div>
      </div>
    </div>
  </section>
);
